var _path, _path2, _path3, _path4, _path5, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFlg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_flg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 64,
    viewBox: "0 0 38 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3976",
    "data-name": "\\uD328\\uC2A4 3976",
    d: "M248.282,136.381A1.717,1.717,0,0,0,250,138.1h17.955a1.717,1.717,0,0,0,1.717-1.717V116.3a1.717,1.717,0,0,0-1.717-1.717H250a1.717,1.717,0,0,0-1.717,1.717Z",
    transform: "translate(-231.672 -99.984)",
    fill: "#ed412f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3977",
    "data-name": "\\uD328\\uC2A4 3977",
    d: "M250,114.583a1.717,1.717,0,0,0-1.717,1.717v18.113h7.7A1.717,1.717,0,0,0,257.7,132.7V114.583Z",
    transform: "translate(-231.409 -99.981)",
    fill: "#231f20",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3978",
    "data-name": "\\uD328\\uC2A4 3978",
    d: "M136.67,89.624a1.717,1.717,0,0,0,1.717,1.717h17.955a1.717,1.717,0,0,0,1.717-1.717V69.543a1.717,1.717,0,0,0-1.717-1.717H138.387a1.717,1.717,0,0,0-1.717,1.717Z",
    transform: "translate(-133.683 -59.158)",
    fill: "#ff4d30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3979",
    "data-name": "\\uD328\\uC2A4 3979",
    d: "M140.032,89.624V69.543a1.717,1.717,0,0,1,1.717-1.717h-3.363a1.717,1.717,0,0,0-1.717,1.717V89.624a1.717,1.717,0,0,0,1.717,1.717h3.363A1.717,1.717,0,0,1,140.032,89.624Z",
    transform: "translate(-133.682 -59.158)",
    fill: "#231f20",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3980",
    "data-name": "\\uD328\\uC2A4 3980",
    d: "M129.344,83.1a1.072,1.072,0,0,1-1.073-1.071V22.969a1.073,1.073,0,0,1,2.147,0V82.028A1.072,1.072,0,0,1,129.344,83.1Z",
    transform: "translate(-126.357 -19.099)",
    fill: "#92b5c4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_471",
    "data-name": "\\uD0C0\\uC6D0 471",
    cx: 2.988,
    cy: 2.988,
    r: 2.988,
    transform: "translate(0)",
    fill: "#ffd960"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2371",
    "data-name": "\\uADF8\\uB8F9 2371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3983",
    "data-name": "\\uD328\\uC2A4 3983",
    d: "M115.618,2.988A2.988,2.988,0,0,1,117.443.235a2.988,2.988,0,1,0,0,5.505A2.988,2.988,0,0,1,115.618,2.988Z",
    transform: "translate(-113.293)",
    fill: "#231f20",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlg);
export default __webpack_public_path__ + "static/media/ic_flg.3d64641f5a6128fc6798a27bc1453916.svg";
export { ForwardRef as ReactComponent };